<template>
    <div class="col-md-6 p-0 mr-5">
        <div class="calculator__step">
            <div class="calculator__step--top">
                <b>STORAGE CALCULATOR</b>
            </div>
            <div class="row m-0 calculator__step--content pl-4 pr-4 pt-4">
                <div class="col-md-3" style="color: #1D3354;">
                    <h3>Step 1</h3>
                    <p> Step 1 from 5 </p>
                </div>
                <div class="col-md">
                    <b-form-group label="Freight Mode">
                        <div class="row m-0">
                            <b-form-radio
                                class="mr-3"
                                v-model="form.freightType"
                                v-for="(item, i) in optionsFreight"
                                @change="shipmentType= ''"
                                :key="i"
                                :value="item.value"
                                > {{item.text}} </b-form-radio>
                        </div>
                     </b-form-group>
                    <b-form-group>
                        <div class="row m-0 label pb-2 align-items-center">
                          <b>Shipment Type</b>
                           <div class="__errorMsg text-left ml-2"> {{shipment_message}} </div>
                        </div>
                        <div  class="row m-0">
                            <b-form-radio
                                class="mr-3"
                                v-model="shipmentType"
                                v-for="(item, i) in form.freightType === 'air' ? optionsShipment1 : optionsShipment2"
                                :key="i"
                                @change="shipment_message = ''"
                                :value="item.value"
                                > {{item.text}} </b-form-radio>
                        </div>
                    </b-form-group>
                </div>
            </div>
            <div class="row m-0 calculator__step--bottom justify-content-end p-4 pt-5">
                <button class="_global__button--corporite pl-4 pr-4" @click="emitToParent('StartCalculator')">Back</button>
                <button class="_global__button--corporite pl-4 pr-4 ml-4" @click="emitToParent('CalcStep2')">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CalcStep1',
  data: () => ({
    shipment_message: '',
    shipmentType: '',
    form: {
      stepName: '',
      freightType: 'air',
      shipmentType: '',
      volume_parameter: ''
    },
    optionsFreight: [
      { text: 'Air', value: 'air' },
      { text: 'Ocean', value: 'ocean' }
    ],
    optionsShipment1: [
      { text: 'Air Cargo', value: 'air cargo' }
    ],
    optionsShipment2: [
      { text: '20 ft FCL', value: '20ft' },
      { text: '40 ft FCL', value: '40ft' },
      { text: 'LCL', value: 'lcl' }
    ],
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 1,
      stepName: 'Choose Freight Mode, Shipment Type',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.form
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    emitToParent (data) {
      if (data === 'StartCalculator' || this.shipmentType) {
        this.form.shipmentType = this.shipmentType
        this.form.stepName = data
        this.$emit('changeParameter', this.form.volume_parameter)
        this.$emit('activeForm', this.form)
      } else { this.shipment_message = 'This field is required*' }
    }
  },
  watch: {
    shipmentType (data) {
      this.form.volume_parameter = (data === 'air cargo') || (data === 'air courier') ? 'Kg' : data === 'lcl' ? 'CBM' : 'Ctn'
      this.form.shipmentType = data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/CalcStep1.vue